'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _styledComponents=require('styled-components');Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _styledComponents.css}});


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/styles/css.js
 **/